module.exports = __webpack_public_path__ + "static/media/mini.fedf84ac.png";